import { useTranslation } from 'react-i18next';
import { ClaimStatusHistory, ClaimStatusSlug } from '@/types';
import { getClaimStatusTagData, getClaimStatusLabel } from '@/utils/claimHelpers';
import { formatDateByDayjs } from '@/utils';

interface ClaimTimelineProps {
  statuses: ClaimStatusHistory[];
}

const ISSUER_DEFAULTS: Record<ClaimStatusHistory['issuer_type'], string> = {
  merchant: 'Merchant',
  admin: 'Admin',
  system: 'System',
  carrier: 'Carrier',
};

const ClaimTimeline = ({ statuses }: ClaimTimelineProps) => {
  const { t } = useTranslation();

  const sorted = [...statuses].reverse();

  return (
    <div className="flex flex-col">
      {sorted.map((entry, index) => {
        const slug = entry.slug as ClaimStatusSlug;
        const { iconColor } = getClaimStatusTagData(slug);
        const statusLabel = getClaimStatusLabel(slug, t);
        const issuerLabel = String(
          t(`claim_issuer.${entry.issuer_type}`, {
            defaultValue: ISSUER_DEFAULTS[entry.issuer_type],
          }),
        );
        const isLast = index === sorted.length - 1;

        return (
          <div key={`${entry.slug}-${entry.at}`} className="flex gap-3">
            {/* Dot + line */}
            <div className="flex flex-col items-center">
              <span
                className="mt-1 h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: iconColor }}
              />
              {!isLast && <div className="w-px flex-1 bg-[rgb(232,230,227)] my-1" />}
            </div>

            {/* Content */}
            <div className={`flex flex-col gap-0.5 ${isLast ? '' : 'pb-4'}`}>
              <span className="text-sm font-semibold text-[rgb(57,57,60)]">{statusLabel}</span>
              <div className="flex items-center gap-2">
                <span className="text-xs text-[rgb(115,123,140)]">{issuerLabel}</span>
                <span className="text-xs text-[rgb(115,123,140)]">
                  {formatDateByDayjs(entry.at, 'DD MMM YY HH:mm')}
                </span>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ClaimTimeline;
